import { render, staticRenderFns } from "./BaseEditPageCombobox.vue?vue&type=template&id=660bdc09"
import script from "./BaseEditPageCombobox.vue?vue&type=script&lang=js"
export * from "./BaseEditPageCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports